import Course from './Course'

function  CourseIndex() {
  return (
    <>
      <Course/>
    </>
  )
}

export default CourseIndex
